/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./IconCircle.vue?vue&type=template&id=ca7b4682&scoped=true"
import script from "./IconCircle.vue?vue&type=script&lang=js"
export * from "./IconCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7b4682",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca7b4682')) {
      api.createRecord('ca7b4682', component.options)
    } else {
      api.reload('ca7b4682', component.options)
    }
    module.hot.accept("./IconCircle.vue?vue&type=template&id=ca7b4682&scoped=true", function () {
      api.rerender('ca7b4682', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icon/IconCircle.vue"
export default component.exports